import { c as _c } from "react/compiler-runtime";
type MsTeamsIconProps = {
  readonly className?: string;
};
export function MsTeamsIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g fill="currentColor"><path d="M20.138 9.056a2.093 2.093 0 1 0 0-4.187 2.093 2.093 0 0 0 0 4.187zM19.021 18.797c.135.017.272.026.411.026h.016a3.248 3.248 0 0 0 3.248-3.248v-4.706a.884.884 0 0 0-.884-.883h-2.518c.142.27.22.578.216.904v5.346a6.222 6.222 0 0 1-.489 2.561zM17.21 17.944a3.239 3.239 0 0 1-1.026-2.368v-4.59h1.326v5.284a4.231 4.231 0 0 1-.3 1.674zM13.928 9.032a3.024 3.024 0 1 0-3.32-2.837h1.468c1.023 0 1.852.83 1.852 1.853zM11.928 8.525v-.33h-.405c.125.121.26.232.405.33zM8.276 16.428l.001-.18v-1.072h.473v-4.5h1.75v-.69h1.428v6.442z" /><path d="M8.695 18.428h3.38c1.024 0 1.853-.83 1.853-1.853v-6.59h3.73a.874.874 0 0 1 .852.895v5.367a5.246 5.246 0 0 1-5.117 5.367 5.247 5.247 0 0 1-4.698-3.186z" /><path clipRule="evenodd" d="M12.076 7.195H3.548a.853.853 0 0 0-.852.853v8.527c0 .47.381.853.852.853h8.528c.47 0 .852-.382.852-.853V8.048a.853.853 0 0 0-.852-.853zM5.5 10.675h1.75v4.5h1v-4.5H10v-1H5.5z" fillRule="evenodd" /></g>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden="true" className={className} viewBox="0 0 24 24">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}